import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { AdminApplicationsPage } from "../pages/admin";

export const routes = (
  <Route
    path="/admin/applications"
    element={
      <PrivateRoute>
        <AdminApplicationsPage />
      </PrivateRoute>
    }
  />
);
